import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Auth from '../../../../Layout/Auth';

// Lazy load components
const NotificationList = lazy(() => import('../Pages/NotificationList'));
const AddNotification = lazy(() => import('../Pages/AddNotification'));
const EditNotification = lazy(() => import('../Pages/EditNotification'));
const NotificationView = lazy(() => import('../Pages/NotificationView'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/notification.scss';

function NotificationRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/:lng/notification"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <NotificationList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/notification/list"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <NotificationList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/notification/add"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin']}>
            <Suspense fallback={<Loading />}>
              <AddNotification history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/notification/edit/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin']}>
            <Suspense fallback={<Loading />}>
              <EditNotification history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/notification/view/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff']}>
            <Suspense fallback={<Loading />}>
              <NotificationView history={history} />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  );
};

export default NotificationRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
